const NhlTeamStacking = {
    NHL_TEAM_STACKING_FIRST_STACK: 1,
    NHL_TEAM_STACKING_SECOND_STACK: 2,
    NHL_TEAM_STACKING_THIRD_STACK: 3,

    NHL_TEAM_STACKING_IS_USED: 'NHL_TEAM_STACKING_IS_USED',
    NHL_TEAM_STACKING_SET_RESTRICT_PLAYERS: 'NHL_TEAM_STACKING_SET_RESTRICT_PLAYERS',
    NHL_TEAM_STACKING_SET_COMBO_IS_CHECKED: 'NHL_TEAM_STACKING_SET_COMBO_IS_CHECKED',
    NHL_TEAM_STACKING_SET_COMBO_EXPOSURE: 'NHL_TEAM_STACKING_SET_COMBO_EXPOSURE',
    NHL_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY: 'NHL_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY',
    NHL_TEAM_STACKING_SET_TEAMS_ARE_FORCED_TO_STACKING: 'NHL_TEAM_STACKING_SET_TEAMS_ARE_FORCED_TO_STACKING',
    NHL_TEAM_STACKING_SET_TEAMS: 'NHL_TEAM_STACKING_SET_TEAMS',
    NHL_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED: 'NHL_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED',
    NHL_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE: 'NHL_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE',
    NHL_TEAM_STACKING_SET_TEAM_LINE_GROUP_IS_CHECKED: 'NHL_TEAM_STACKING_SET_TEAM_LINE_GROUP_IS_CHECKED',
    NHL_TEAM_STACKING_SET_TEAM_LINE_GROUPS: 'NHL_TEAM_STACKING_SET_TEAM_LINE_GROUPS',
    NHL_TEAM_STACKING_SET_TEAM_PP_LINE_IS_CHECKED: 'NHL_TEAM_STACKING_SET_TEAM_PP_LINE_IS_CHECKED',
    NHL_TEAM_STACKING_SET_TEAM_PP_LINES: 'NHL_TEAM_STACKING_SET_TEAM_PP_LINES',
    NHL_TEAM_STACKING_SET_TEAM_IS_CHECKED: 'NHL_TEAM_STACKING_SET_TEAM_IS_CHECKED',
    NHL_TEAM_STACKING_SET_TEAM_EXPOSURE: 'NHL_TEAM_STACKING_SET_TEAM_EXPOSURE',
    NHL_TEAM_STACKING_SET_DATA_FROM_STORAGE: 'NHL_TEAM_STACKING_SET_DATA_FROM_STORAGE',
    NHL_TEAM_STACKING_MIRROR_STACK: 'NHL_TEAM_STACKING_MIRROR_STACK',
    NHL_TEAM_STACKING_SET_TEAM_DEFENSEMAN_IS_INCLUDED: 'NHL_TEAM_STACKING_SET_TEAM_DEFENSEMAN_IS_INCLUDED',
};

export default NhlTeamStacking;
